import { ReactNode, useState } from "react";
import { Box, Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { analytics } from "MVVM/Analytics";
import { NewBadge } from "../Badge/New";

interface ITab {
  component: ReactNode;
  name: string;
  title: string;
  type: string;
}

interface ITabsProps {
  active?: number;
  tabs: ITab[];
  color?: string;
}

const Tabs = ({ active, tabs, color }: ITabsProps) => {
  const [activeTab, setActiveTab] = useState(active || 0);

  const updateTabParam = (newTabValue: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("tab", newTabValue);
    window.history.pushState({}, "", url);
  };

  return (
    <Flex height="100%" flexDirection="column">
      <Flex>
        {tabs.length > 1 &&
          tabs.map((tab, index) => (
            <Tab
              key={tab.title}
              active={activeTab === index}
              onClick={() => {
                setActiveTab(index);
                analytics.track("Tab Clicked", { type: tab.type });
                updateTabParam(tab.name);
              }}
              flex="1 1 0"
              color={color}
            >
              <Text variant="text.labelSmall">{tab.title}</Text>
              {tab.type === "Comments" && <NewBadge pl={3} />}
            </Tab>
          ))}
      </Flex>
      <Flex flexGrow="1">
        {tabs.map((tab, index) => (
          <TabContent key={index} active={activeTab === index}>
            {tab.component}
          </TabContent>
        ))}
      </Flex>
    </Flex>
  );
};

const TabContent = styled(Box)<{ active: boolean }>`
  display: ${(props) => (props.active ? "block" : "none")};
  width: 100%;
`;

const Tab = styled(Flex)<{ active: boolean; color?: string }>`
  border-bottom: ${(props) =>
    props.active
      ? `2px solid ${props.color || props.theme.colors.envy}`
      : `2px solid ${props.theme.colors.navy}`};
  color: ${(props) =>
    props.active
      ? props.color || props.theme.colors.envy
      : props.theme.colors.chalk};
  cursor: pointer;
  font-weight: 500;
  justify-content: center;
  padding: 0 0 12px 0;
  position: relative;
`;

export { Tabs };
